import { CLASH_ASSETS, CLASH_CREDITS, CLASH_LINKS, APP_VERSION } from '../../lib/clashConstants'

export const Footer = () => {
  return (
    <footer className="clash-footer">
      <div className="footer-content">
        {/* OCC Games Brand */}
        <div className="footer-brand">
          <img
            src={CLASH_ASSETS.occLogo}
            alt="Roslyn OCC Games"
            className="footer-logo"
            onError={(e) => {
              e.currentTarget.style.display = 'none'
            }}
          />
        </div>

        {/* Game Icons */}
        <div className="footer-game-icons">
          <a href="https://clashdle.roslynocc.com" target="_blank" rel="noopener noreferrer" title="Clashdle">
            <img src="/Clashdle Icon.png" alt="Clashdle" className="footer-game-icon" />
          </a>
          <a href="https://clashconnections.roslynocc.com" target="_blank" rel="noopener noreferrer" title="Connections">
            <img src="/Connections Icon.png" alt="Connections" className="footer-game-icon" />
          </a>
          <a href="https://clashstrands.roslynocc.com" target="_blank" rel="noopener noreferrer" title="Strands">
            <img src="/Strands Icon.png" alt="Strands" className="footer-game-icon" />
          </a>
          <a href="https://clashwordchain.roslynocc.com" target="_blank" rel="noopener noreferrer" title="Word Chain">
            <img src="/Wordchain Icon.png" alt="Word Chain" className="footer-game-icon" />
          </a>
        </div>

        <div className="footer-divider" />

        {/* Credits */}
        <p className="footer-credits">
          Created by <span className="footer-highlight">{CLASH_CREDITS.developers.join(' & ')}</span>
        </p>

        {/* Links */}
        <div className="footer-links">
          <a
            href={CLASH_LINKS.occ}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Visit OCC
          </a>
          <span className="footer-link-sep">•</span>
          <a
            href={CLASH_LINKS.privacy}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Privacy
          </a>
        </div>

        {/* Copyright */}
        <p className="footer-copyright">
          © {CLASH_CREDITS.year} {CLASH_CREDITS.organization} · v{APP_VERSION}
        </p>
      </div>
    </footer>
  )
}
